(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const showcases = document.querySelectorAll('.shop-showcase');
    
    showcases.forEach(function(showcase) {
      const addingText = showcase.dataset.addingText || 'ADDING...';
      const addedText = showcase.dataset.addedText || 'ADDED!';
      const addToCartButtons = showcase.querySelectorAll('.shop-showcase__add-to-cart[data-variant-id]');
      
      addToCartButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const variantId = this.dataset.variantId;
          const productImage = this.dataset.productImage;
          const originalText = this.textContent;
          
          this.disabled = true;
          this.textContent = addingText;
          
          // Use global cart handler with fly-to-cart animation
          if (window.cart) {
            window.cart.addItem(variantId, 1, {
              sourceElement: this,
              imageUrl: productImage,
              onSuccess: () => {
                this.textContent = addedText;
                setTimeout(() => {
                  this.textContent = originalText;
                  this.disabled = false;
                }, 2000);
              },
              onError: () => {
                this.textContent = originalText;
                this.disabled = false;
              }
            });
          } else {
            // Fallback if global cart handler not available
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            })
            .then(response => response.json())
            .then(() => {
              this.textContent = addedText;
              setTimeout(() => {
                this.textContent = originalText;
                this.disabled = false;
              }, 2000);
            })
            .catch(() => {
              this.textContent = originalText;
              this.disabled = false;
            });
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
